import { render, staticRenderFns } from "./ActionSendMessage.vue?vue&type=template&id=4504921e&"
import script from "./ActionSendMessage.vue?vue&type=script&lang=js&"
export * from "./ActionSendMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports